import { fetchEntities } from 'actions/entities'
import React from 'react'
import { connect } from 'react-redux'
import { Segment } from "semantic-ui-react";
import Signature from "./Signature";
import TemplatesListContainer from "./TemplatesListContainer";

class Templates extends React.Component {
  componentDidMount() {
    this.props.fetchEntities()
  }

  render() {
    return (
      <Segment basic>
        <TemplatesListContainer kind={'letter'}/>
        <TemplatesListContainer kind={'note'}/>
        {this.props.view !== 'admin' && <Signature/>}
      </Segment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.meta.template?.loading,
    error: state.meta.template?.error,
    view: state.view
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('templates'))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Templates)
